import React, { useContext, useState, useEffect } from "react";
import { SectionsContext } from "../../context/SectionsContext";
import { CourseAccessesContext } from "../../context/CourseAccessesContext";
import { isVideoAccessExpired } from "../../utils/course";
import SectionCard from "./SectionCard";
import moment from "moment";

// Set to true to require completing the previous section before unlocking the next module
const REQUIRE_SECTION_COMPLETION = true;

const Sections = ({ course_id }) => {
  const [hasAccess, setHasAccess] = useState(true);
  const { sections, getSectionsCourse } = useContext(SectionsContext);
  const { course_accesses } = useContext(CourseAccessesContext);

  // expiration_date lives on the user's course access, not on the course
  const access = Array.isArray(course_accesses)
    ? course_accesses.find(
        (a) => parseInt(a.course_id) === parseInt(course_id)
      )
    : null;

  useEffect(() => {
    getSectionsCourse(course_id);
  }, []);

  useEffect(() => {
    if (access && access !== null) {
      if (isVideoAccessExpired(access)) {
        setHasAccess(false);
      }
    }
  }, [access]);

  const renderSections = () => {
    if (Array.isArray(sections)) {
      if (!hasAccess) {
        return (
          <div className="container">
            <div className="card text-center bg-light shadow">
              <i className="fa fa-lock fa-3x"></i>
              <h2 className="my-3">Ups! Ya no tienes acceso a los videos</h2>
              <p>
                Tienes hasta el{" "}
                {moment.utc(access.expiration_date).add(7, "days").format(
                  "DD MMM YYYY"
                )}{" "}
                para subir tu examen final
              </p>
            </div>
          </div>
        );
      }
      return sections.map((section, index) => {
        const previous = index > 0 ? sections[index - 1] : null;
        const locked =
          REQUIRE_SECTION_COMPLETION &&
          previous !== null &&
          (!Array.isArray(previous.completed) ||
            previous.completed.length === 0);
        return (
          <SectionCard
            key={section.section_id}
            section={section}
            course_id={course_id}
            locked={locked}
          />
        );
      });
    }
  };

  return (
    <div className="container-fluid px-0 py-0">
      <div className="row g-4 ps-lg-0 px-0 text-dark col-12 mx-0 px-lg-0">
        {renderSections()}
      </div>
    </div>
  );
};

export default Sections;
